import React, { Component, createRef } from 'react';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import './Navbar.scss';

import commonConstant from '../../../common/_commonConstant';
import { randomNumber } from '../../../common/_commonFunction';
import {
  buildingRefNumber,
  buildingName,
  DropdownSearch,
  formatPhoneNumber,
  history,
  isAccounting,
  isAdmin,
  isCashier,
  isOperation,
  isSuperAdmin,
  passParamsToPath,
  phoneNumber,
  userEmail,
  userName,
  userRoleName,
  validateToShowDash,
  buildingID,
} from '../../../helpers';
import { Loading, UserProfile } from '../../../components';
import {
  fetchGetBuildingByBuildingID,
  fetchGetBuildingBySearch,
  fetchGetProblems,
  fetchGetProfile,
} from '../../../actions';

class Navbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'showProfile': false,
      'search': null,
      'loading': false,
      'editProfile': false,
    };
    this.profile = createRef();
    this.search = createRef();

    if (!props.getProfile.data) {
      props.dispatch(fetchGetProfile());
    } else if (
      (props.match.path === commonConstant.pathAccountingReport && isSuperAdmin(props.getProfile.data) && isAccounting(props.getProfile.data)) ||
      (!props.getBuildingByRefNo.data && isCashier(props.getProfile.data)) ||
      (!props.getBuildingByRefNo.data && isOperation(props.getProfile.data))
    ) {
      props.dispatch(fetchGetBuildingByBuildingID(buildingID(props.getProfile.data)));
      if (isCashier(props.getProfile.data) && !props.getProblems.data) {
        props.dispatch(fetchGetProblems(commonConstant.filterProblemsCashier));
      } else if (isOperation(props.getProfile.data) && !props.getProblems.data) {
        props.dispatch(fetchGetProblems());
      }
    }
    this.handleCheckPathToAccess(props.match.path, props.getProfile.data);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { match, getBuildingByRefNo, getBuildingBySearch, getProfile } = this.props;
    const { search } = this.state;

    if (nextProps.match.path !== match.path && nextProps.match.path === commonConstant.pathSelectBuilding) {
      return this.setState({ 'search': null });
    } else if (
      nextProps.match.path !== match.path &&
      nextProps.match.path === commonConstant.pathAccountingReport &&
      !search &&
      (isAccounting(nextProps.getProfile.data) || isSuperAdmin(nextProps.getProfile.data) || isOperation(nextProps.getProfile.data))
    ) {
      return this.props.dispatch(fetchGetBuildingByBuildingID(nextProps.match.params.buildingID));
    } else if (nextProps.getBuildingByRefNo.status === 200 && nextProps.getBuildingByRefNo !== getBuildingByRefNo) {
      return this.setState({
        'search': {
          'label': `${nextProps.getBuildingByRefNo.data.building.buildingRefNo} - ${nextProps.getBuildingByRefNo.data.building.buildingName}`,
          'value': nextProps.getBuildingByRefNo.data.building.buildingRefNo,
        },
      });
    } else if (nextProps.getBuildingBySearch && nextProps.getBuildingBySearch !== getBuildingBySearch) {
      return this.setState({ 'loading': false });
    } else if (nextProps.getProfile && nextProps.getProfile !== getProfile) {
      this.handleCheckPathToAccess(nextProps.match.path, nextProps.getProfile.data);
      if (isCashier(nextProps.getProfile.data) && !nextProps.getProblems.data) {
        this.props.dispatch(fetchGetProblems(commonConstant.filterProblemsCashier));
      } else if (isOperation(nextProps.getProfile.data) && !nextProps.getProblems.data) {
        this.props.dispatch(fetchGetProblems());
      }
      if (
        (nextProps.match.path === commonConstant.pathAccountingReport && (isSuperAdmin(nextProps.getProfile.data) || isAccounting(nextProps.getProfile.data))) ||
        (!nextProps.getBuildingByRefNo.data && isCashier(nextProps.getProfile.data)) ||
        (!nextProps.getBuildingByRefNo.data && isOperation(nextProps.getProfile.data))
      ) {
        return this.props.dispatch(fetchGetBuildingByBuildingID(buildingID(nextProps.getProfile.data)));
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = event => {
    if (this.state.showProfile && this.profile.current && !this.profile.current.contains(event.target)) {
      return this.setState({ 'showProfile': false });
    }
  }

  handleCheckPathToAccess = (path, getProfile) => {
    // TODO: permission access page
    try {
      if (path && getProfile) {
        switch (path) {
          case commonConstant.pathSelectBuilding:
          case commonConstant.pathAccountingReport:
            if (!isSuperAdmin(getProfile) && !isAccounting(getProfile)) {
              return history.push(commonConstant.pathCheckRedirect);
            }
            return null;
          case commonConstant.pathSearchVehicleLicensePlate:
          case commonConstant.pathParkingStatus:
            if (!isCashier(getProfile)) {
              return history.push(commonConstant.pathCheckRedirect);
            }
            return null;
          case commonConstant.pathOperationReport:
          case commonConstant.pathExportOperationReport:
          case commonConstant.pathOperationDashboard:
            if (!isOperation(getProfile)) {
              return history.push(commonConstant.pathCheckRedirect);
            }
            return null;
          case commonConstant.pathUserManagement:
          case commonConstant.pathManageMembership:
            if (!isAdmin(getProfile)) {
              return history.push(commonConstant.pathCheckRedirect);
            }
            return null;
          default:
            return null;
        }
      }
    } catch (error) {
      return null;
    }
  };

  handleShowBackBTN = () => {
    const { 'match': { path }, getProfile } = this.props;

    if (path === commonConstant.pathAccountingReport) {
      return isSuperAdmin(getProfile.data);
    }
    return false;
  }

  handlePathRedirect = () => {
    const { 'match': { path } } = this.props;

    if (path === commonConstant.pathAccountingReport) {
      return commonConstant.pathSelectBuilding;
    }
    return null;
  }

  handleShowTitle = () => {
    const { 'match': { path, params }, getProfile, currentBuildingDataPath } = this.props;    

    switch (path) {
      case commonConstant.pathAccountingReport:
        return (
          isSuperAdmin(getProfile.data) ?
            'ACCOUNTING REPORT'
            : isAccounting(getProfile.data) ?
              `ACCOUNTING REPORT${params.buildingRefNo === buildingRefNumber(getProfile.data) ? ` : อาคาร ${buildingRefNumber(getProfile.data) ? `${buildingRefNumber(getProfile.data)} ` : ''}${buildingName(getProfile.data) ? buildingName(getProfile.data) : ''}` : ''}`
              : null
        );
      case commonConstant.pathSearchVehicleLicensePlate:
      case commonConstant.pathParkingStatus:
        return `${buildingRefNumber(getProfile.data) ? buildingRefNumber(getProfile.data) : ''} ${buildingName(getProfile.data) ? buildingName(getProfile.data) : ''}`;
      case commonConstant.pathOperationReport:
      case commonConstant.pathExportOperationReport:
        return `OPERATION REPORT : อาคาร${buildingRefNumber(getProfile.data) ? ` ${buildingRefNumber(getProfile.data)} ` : ''}${buildingName(getProfile.data) ? buildingName(getProfile.data) : ''}`;
      case commonConstant.pathOperationDashboard:
        return `OPERATION DASHBOARD : อาคาร${buildingRefNumber(getProfile.data) ? ` ${buildingRefNumber(getProfile.data)} ` : ''}${buildingName(getProfile.data) ? buildingName(getProfile.data) : ''}`;
      case commonConstant.pathManageMembership:      
        return `MANAGE MEMBERSHIP : อาคาร${buildingRefNumber(getProfile.data) ? ` ${buildingRefNumber(getProfile.data)} ` : ''}${buildingName(getProfile.data) ? buildingName(getProfile.data) : ''}`;
      case commonConstant.pathUserManagement:
        return 'USER MANAGEMENT';
      case commonConstant.pathCreateBuilding:
        return 'Create new building';
      case commonConstant.pathManageTenantMembership: 
        return `MANAGE MEMBERSHIP : ${params.tenantName}`; 
      case commonConstant.pathParkingDayConfig:
        return `PARKING DAY CONFIG : ${currentBuildingDataPath.data ? currentBuildingDataPath.data.buildingRefNo : params.buildingRefNo}`; 
      case commonConstant.pathCustomDayConfig:
        return `CUSTOM PARKING DAY CONFIG : ${currentBuildingDataPath.data ? currentBuildingDataPath.data.buildingRefNo : params.buildingRefNo}`; 
      case commonConstant.pathTenantManagement:
        return `TENANT MANAGEMENT : ${currentBuildingDataPath.data ? currentBuildingDataPath.data.buildingRefNo : params.buildingRefNo}`; 
      case commonConstant.pathOnboardForm:
        return `ONBORD FORM : ${currentBuildingDataPath.data ? currentBuildingDataPath.data.buildingRefNo : params.buildingRefNo}`; 
      default:
        return null;
    }
  }

  handleSearchBuildingRefNo = event => {
    if (event.target.value) {
      this.props.dispatch(fetchGetBuildingBySearch(event.target.value));
      return this.setState({ 'search': event.target.value, 'loading': true });
    }
    return this.setState({ 'search': event.target.value });
  }

  handleClearValue = key => {
    if (key === 'search') {
      return this.setState({ 'search': null });
    }
  }

  handleShowProfile = () => this.setState({ 'showProfile': !this.state.showProfile });

  handleSetItemsSearch = () => {
    const { getBuildingBySearch } = this.props;

    if (getBuildingBySearch.data) {
      return getBuildingBySearch.data.map(ele => (
        <div
          className="item"
          key={randomNumber()}
          data-value={ele.value ? ele.value : ele.label}
          onClick={() => this.handleSelectBuildingRefNo({ ...ele, 'label': `${ele.buildingRefNo} ${ele.buildingName}` })}
        >
          {`${ele.buildingRefNo} ${ele.buildingName}`}
        </div>
      ));
    }
    return null;
  }

  handleDisabledSearchBuildingRefNo = () => {
    const { search } = this.state;

    try {
      return search.value ? true : false;
    } catch (error) {
      return false;
    }
  }

  handleSelectBuildingRefNo = search => {
    this.setState({ search });
    this.search.current.handleShowItem();

    return history.push(passParamsToPath(commonConstant.pathAccountingReport, { 'buildingID': search.buildingID, 'buildingRefNo': search.buildingRefNo }));
  }

  handleShowLayoutCenter = () => {
    try {
      const { 'match': { path }, getProfile } = this.props;
      const { search } = this.state;

      if (isSuperAdmin(getProfile.data) && (path === commonConstant.pathAccountingReport || path === commonConstant.pathSelectBuilding)) {
        return (
          <div className="search-building">
            {path === commonConstant.pathAccountingReport ? <div className="building">อาคาร </div> : null}
            <DropdownSearch
              ref={this.search}
              id="search-building"
              template="a"
              value={search}
              icon="fas fa-search"
              placeholder="ค้นหาอาคาร"
              onChange={this.handleSearchBuildingRefNo}
              handleClearValue={() => this.handleClearValue('search')}
              disabled={this.handleDisabledSearchBuildingRefNo()}
              items={this.handleSetItemsSearch()}
            />
          </div>
        );
      }
      return null;
    } catch (error) {
      return null;
    }
  }

  handleDetail = () => {
    const { getProfile } = this.props;

    if (isSuperAdmin(getProfile.data)) {
      return (
        <div>
          <div className="box-info">
            <span className="info" id="profile-email">
              {validateToShowDash(userEmail(getProfile.data))}
            </span>
          </div>
          <div className="box-tool">
            <div
              id="change-password"
              className="change-password"
              onClick={this.handleEditProfile}
            >
              Change password
            </div>
          </div>
        </div>
      );
    } else if (userEmail(getProfile.data)) {
      return (
        <div>
          <div className="box-info">
            <span className="info" id="profile-tel">
              tel: {formatPhoneNumber(phoneNumber(getProfile.data))}
            </span>
          </div>
          <div className="box-info">
            <span className="info" id="profile-email">{validateToShowDash(userEmail(getProfile.data))}</span>
          </div>
          <div className="box-tool">
            <span
              id="change-password"
              className="change-password"
              onClick={this.handleEditProfile}
            >
              Change password
            </span>
          </div>
        </div>
      );
    }
    return (
      <div>
        <div className="box-info">
          <span className="info" id="profile-tel">
            tel: {formatPhoneNumber(phoneNumber(getProfile.data))}
          </span>
        </div>
        <div className="box-tool">
          <div
            id="change-password"
            className="change-password"
            onClick={this.handleEditProfile}
          >
            Change password
          </div>
        </div>
      </div>
    );
  }

  handleEditProfile = () => this.setState({ 'editProfile': true, 'showProfile': false });

  handleCloseEditProfile = () => this.setState({ 'editProfile': false });

  handleDummyWidth = () => {
    try {
      const { 'match': { path }, getProfile } = this.props;

      switch (path) {
        case commonConstant.pathAccountingReport:
          if (isSuperAdmin(getProfile.data)) {
            return '127px';
          }
          return null;
        case commonConstant.pathSelectBuilding:
          if (isSuperAdmin(getProfile.data)) {
            return '67px';
          }
          return null;
        case commonConstant.pathOperationReport:
          if (isOperation(getProfile.data)) {
            return '40px';
          }
          return null;
        default:
          return null;
      }
    } catch (error) {
      return null;
    }
  }

  render() {
    const { loading, showProfile, editProfile } = this.state;
    const { getProfile } = this.props;

    if (!getProfile.data) {
      return <Loading />;
    }

    return (
      <div className={`Navbar${isCashier(getProfile.data) ? ' x2' : ''}`}>
        {loading ? <Loading /> : null}
        <div className="box-logo">
          <span className="icon icon-logo" onClick={() => history.push(commonConstant.pathCheckRedirect)} />
        </div>
        <div className="box">
          <div className="detail-center">
            <div className="box-detail">
              <div className="box-menu">
                {
                  this.handleShowBackBTN() ?
                    <Link to={this.handlePathRedirect()} id="btn-back-page" className="back">
                      <span className="icon fas fa-arrow-left" />
                    </Link>
                    : null
                }
                <span className="menu" id="navbar-menu-title">{this.handleShowTitle()}</span>
              </div>
            </div>
            {this.handleShowLayoutCenter()}
            <div style={{ 'width': this.handleDummyWidth() }} />
          </div>
          <div className="box-profile" ref={this.profile}>
            <div className="left">
              <div className="name" id="profile-username">
                {validateToShowDash(userName(getProfile.data))}
              </div>
              <div className="role">
                {
                  !isCashier(getProfile.data) &&
                  <span className="role-name" id="profile-role-name">
                    {validateToShowDash(userRoleName(getProfile.data))}
                  </span>
                }
                <span id="view-profile" className={`link${showProfile ? '' : ' active'}`}
                  onClick={this.handleShowProfile}>
                  view profile
                </span>
              </div>
            </div>
            <div className="right">
              <Link to={commonConstant.pathLogout} className="box-logout" id="btn-logout">
                <span className="icon fas fa-sign-out-alt" />
              </Link>
            </div>
            <div className={`bottom${showProfile ? ' active' : ''}`}>
              {this.handleDetail()}
            </div>
          </div>
          {editProfile ? <UserProfile show={editProfile} handleCloseModal={this.handleCloseEditProfile} /> : null}
        </div>
      </div>
    );
  }
}

Navbar.propTypes = {
  'dispatch': PropTypes.func.isRequired,
  'match': PropTypes.shape({
    'path': PropTypes.string,
    'params': PropTypes.shape({
      'buildingID': PropTypes.string,
      'buildingRefNo': PropTypes.string,
    }),
  }),
  'getProfile': PropTypes.shape({
    'data': PropTypes.shape({
      'userRole': PropTypes.shape({
        'userRoleName': PropTypes.string,
      }),
      'user': PropTypes.shape({
        'userName': PropTypes.string,
        'userEmail': PropTypes.string,
      }),
      'building': PropTypes.shape({
        'buildingID': PropTypes.string,
        'buildingName': PropTypes.string,
        'buildingRefNo': PropTypes.string,
      }),
    }),
  }),
  'getBuildingByRefNo': PropTypes.shape({
    'status': PropTypes.any,
    'data': PropTypes.shape({
      'building': PropTypes.shape({
        'buildingName': PropTypes.string,
        'buildingRefNo': PropTypes.string,
      }),
    }),
  }),
  'getBuildingBySearch': PropTypes.shape({
    'status': PropTypes.any,
    'data': PropTypes.array,
  }),
  'getProblems': PropTypes.shape({
    'data': PropTypes.array,
  }),
};

const mapStateToProps = ({ getProfile, getBuildingByRefNo, getBuildingBySearch, getProblems, currentBuildingDataPath }) => ({
  getProfile,
  getBuildingByRefNo,
  getBuildingBySearch,
  getProblems,
  currentBuildingDataPath,
});

export default connect(mapStateToProps)(withRouter(Navbar));
